import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'unistore/react';
import millify from 'millify';

import BbCoinsTable from '@appComponents/bb-dashboard/bb-coins-table';

import { Link, Button, SEO } from '@components';
import CYtPlaya from '@components/Youtube';
import Modal from '@components/Modal';

import { getMyIPDetails } from '@utils/cred';

import { openNewLink } from '@utils/customLib';
import { balanceCoins } from '@utils/params';
import { getRate } from '@utils/storeUtils';

import hero_banner from '@img/v2/hero_desktop.svg';
import ring_pattern from '@img/v2/ring.svg';

import pattern_1 from '@img/v2/pattern-1.svg';
import pattern_2 from '@img/v2/pattern-2.svg';
import pattern_3 from '@img/v2/pattern-3.svg';
import pattern_4 from '@img/v2/pattern-4.svg';
import pattern_5 from '@img/v2/pattern-5.svg';
import pattern_6 from '@img/v2/pattern-6.svg';
import pattern_7 from '@img/v2/pattern-7.svg';
import pattern_8 from '@img/v2/pattern-8.svg';

import fill_details_img from '@img/v2/fill-details.png';
import start_trading_img from '@img/v2/start-trading.png';
import user_pic_1 from '@img/v2/user_pic_1.png';
import user_pic_2 from '@img/v2/user_pic_2.png';
import user_pic_3 from '@img/v2/user_pic_3.png';
import box_pic from '@img/v2/box.svg';
import boxes_pic from '@img/v2/boxes.svg';
import box2_pic from '@img/v2/boxes-2.svg';

import slide_1 from '@img/v2/slide1.png';
import slide_2 from '@img/v2/slide2.png';
import slide_3 from '@img/v2/slide3.png';

import fact_1 from '@img/v2/fact-1.svg';
import fact_2 from '@img/v2/fact-2.svg';
import fact_3 from '@img/v2/fact-3.svg';

import why_bitbns_pic from '@img/v2/why_bitbns_illustration.svg';
import why_bitbns_1 from '@img/v2/why-bitbns-1.png';
import why_bitbns_2 from '@img/v2/why-bitbns-2.png';
import why_bitbns_3 from '@img/v2/why-bitbns-3.png';
import why_bitbns_4 from '@img/v2/why-bitbns-4.png';
import why_bitbns_5 from '@img/v2/why-bitbns-5.png';
import turkeyFlag from '@img/v2/turkeyFlag.svg';
import worldGlobe from '@img/v2/world.svg';

const CountryPageChooseModal = () => {
	const [modalState, setModalState] = useState(false);

	const checkCountryCode = async () => {
		try {
			const data = (await getMyIPDetails()) as {
				countryCode?: string;
			};

			if (data) {
				if (data?.countryCode === 'TR') {
					setModalState(true);
				}
			}
		} catch (error) {
			console.log('countryCode', error);
		}
	};

	useEffect(() => {
		checkCountryCode().catch(console.log);
	}, []);

	return (
		<Modal
			openMoi={modalState}
			bodyClassName="p-0"
			hideHeader
			customWrapper="max-w-3xl"
			modalClose={() => {
				setModalState(false);
			}}
		>
			<div className="p-8 text-gray-700 text-center">
				<p>Which Bitbns site would you like to visit?</p>
				<div className="grid grid-cols-2 gap-10 mt-10">
					<div className="flex flex-col tems-start gap-y-6 items-center">
						<img
							// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
							src={turkeyFlag.src}
							height="56"
							width="56"
							alt="turkey"
						/>
						<p>Türkiye</p>
						<Button
							link="/tr"
							className="bg-primary10 text-primary200 hover:bg-primary20 px-10"
						>
							Visit Now
						</Button>
					</div>
					<div className="flex flex-col tems-start gap-y-6 items-center">
						<img
							// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
							src={worldGlobe.src}
							height="56"
							width="56"
							alt="International"
						/>
						<p>International</p>
						<Button
							onClick={() => setModalState(false)}
							className="bg-primary10 text-primary200 hover:bg-primary20 px-10"
						>
							Continue Here
						</Button>
					</div>
				</div>
			</div>
		</Modal>
	);
};
const goToAfterSigninPage = () => {
	const afterSignInPage =
		window.localStorage.getItem('afterSignInPage') || null;
	switch (+afterSignInPage) {
		case 1:
			return '/trade/#/markets';
		case 2:
			return '/trade/#/btc';
		default:
			return '/trade';
	}
};

const Home = ({ currentRate, isLoggedIn }) => {
	const [tradeVolume24h, set24hVolume] = useState(0);

	const getExchangeStats = btcPrice => {
		const promise = fetch(
			'https://api.coingecko.com/api/v3/exchanges/bitbns'
		);
		promise
			.then(response => response.json())
			.then((data: { trade_volume_24h_btc: number }) => {
				if (data.trade_volume_24h_btc && btcPrice) {
					set24hVolume(data.trade_volume_24h_btc * btcPrice);
				}
			})
			.catch(console.log);
	};

	useEffect(() => {
		if (process.env.NODE_ENV !== 'development') {
			if (isLoggedIn === 1) {
				window.location.href = goToAfterSigninPage();
			}
		}
	}, [isLoggedIn]);

	useEffect(() => {
		const { lastTradePrice } = getRate('btc', 1) as {
			lastTradePrice?: number;
		};

		getExchangeStats(lastTradePrice);
	}, [currentRate]);

	const titleText =
		'Buy Bitcoin & Cryptocurrency in India | Bitcoin Exchange | Cryptocurrency Exchange';
	const description =
		'The fastest and easiest way to buy & sell Bitcoin (BTC) on Bitbns cryptocurrency exchange in India. Trade Cryptocurrencies in INR on Bitbns at a Lowest trading fee in India. Get Free Bitcoin in our Flash Sale.';
	const url = 'https://bitbns.com';

	return (
		<Fragment>
			<SEO title={titleText} description={description} url={url} />
			<CountryPageChooseModal />
			<div className="text-white pt-10">
				<div className="container flex flex-col sm:flex-row justify-between overflow-hidden">
					<div className="flex-shrink-0 sm:mr-12 md:mr-24 pt-8">
						<h1 className="font-bold text-2xl md:text-4xl leading-tight">
							40 lakh+ Indians trust <br />
							Bitbns for buying crypto
						</h1>
						<p className="my-4 text-xl md:text-2xl opacity-50">
							Buy Bitcoin and more with as <br /> little as ₹100
						</p>

						<Button
							className="my-8 rounded-full block text-sm md:text-lg"
							variant="primary"
							onClick={() => {
								openNewLink('/trade/#/signup');
							}}
						>
							<b>Sign Up Now &rarr;</b>
						</Button>
					</div>

					<div className="m-auto order-first sm:order-last">
						<img
							// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
							src={hero_banner.src}
							alt="hero_banner"
							width="659"
							height="492"
						/>
					</div>
				</div>
			</div>
			<div className="u-scrollBar u-scrollBarSmall--light">
				<div className="container flex justify-between items-center overflow-auto scrolling-touch lg:w-10/12 m-auto snap-x will-change-[opacity]">
					<a
						className="c-links c-links--white"
						target="_blank"
						rel="noopener noreferrer"
						href="https://bitbns.com/trade/?utm_source=bitbns&utm_medium=homeBanner#/predict-and-win/"
					>
						<img
							src="https://bitbns.com/assets/img/banners/homeBanner__pnw.png"
							alt="bitbns new"
							className="rounded-lg cursor-pointer snap-start max-w-[400px]"
							width="400"
							height="218"
						/>
					</a>
					<a
						className="c-links c-links--white"
						target="_blank"
						rel="noopener noreferrer"
						href="http://launchonascent.com/?utm_source=bitbns&utm_medium=homeBanner"
					>
						<img
							src={slide_1.src}
							alt="bitbns new"
							className="rounded-lg cursor-pointer snap-start max-w-[400px]"
							width="400"
							height="218"
						/>
					</a>
					<a
						className="c-links c-links--white"
						target="_blank"
						rel="noopener noreferrer"
						href="https://bitbns.com/trade/?utm_source=bitbns&utm_medium=homeBanner#/fixed-deposits"
					>
						<img
							src={slide_2.src}
							alt="trading fee"
							className="rounded-lg cursor-pointer snap-start max-w-[400px]"
							width="400"
							height="218"
						/>
					</a>
					<Link href="/fees/">
						<a href="/fees/" className="c-links c-links--white">
							<img
								src={slide_3.src}
								alt="xrp sale"
								className="rounded-lg cursor-pointer snap-start max-w-[400px]"
								width="400"
								height="218"
							/>
						</a>
					</Link>
					{/* {announcements.map(({ id, img, title }) => (
					<img
						key={id}
						src={img.src}
						alt={title}
						className="rounded-lg mr-12 last:mr-0 last:ml-12 cursor-pointer"
						css={css`
							scroll-snap-align: start;
							max-width: 400px;
						`}
					/>
				))} */}
				</div>
			</div>
			<div>
				<div className="container py-16 pb-20">
					<BbCoinsTable />
				</div>
				{/* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */}
				<img src={pattern_1.src} alt="pattern" className="w-full" />
			</div>
			<div className="bg-primary500 pb-20 -mt-1 relative z-10">
				<div className="flex flex-col items-center justify-center m-auto text-center text-white w-11/12 sm:w-4/5">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={ring_pattern.src}
						alt="pattern"
						className="-mt-40 md:-mt-56"
					/>
					<p className="md:w-1/2 leading-normal text-lg mt-8">
						Bitbns truly impress me alot, I never expected an Indian
						exchange to provide such a wide range of features with
						such flexibility. Their deposit system and customer
						service is the best in Indian crypto market. It is a
						very secure platform with a genius team and multiple
						products.
					</p>
					<div className="flex justify-between items-center my-12">
						<div className="mr-5">
							<img
								src={user_pic_1.src}
								alt="user-pic"
								width="55"
								height="55"
								className="rounded-full"
							/>
						</div>
						<div className="text-left">
							<p className="text-orange-400 mb-2">
								Mr. Sabarish Yanduru
							</p>
							<p className="text-sm">Data Analyst</p>
						</div>
					</div>
					<Button
						className="rounded-full leading-normal text-sm md:text-md"
						variant="primary"
						onClick={() => {
							openNewLink('/trade/#/signup');
						}}
					>
						Buy or Sell Cryptocurrency from Bitbns
					</Button>
				</div>

				<img
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
					src={pattern_2.src}
					alt="pattern"
					className="absolute top-0 hidden md:inline-block"
				/>
			</div>
			<img
				// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
				src={pattern_3.src}
				alt="pattern"
				className="w-full"
			/>
			<div className="-mt-12">
				<div className="text-white pb-20">
					<h3 className="text-4xl text-center my-24">
						Bitbns is for Everyone
					</h3>
					<div className="container mb-20 u-scrollBar u-scrollBarSmall--light">
						<div className="flex justify-between overflow-auto scrolling-touch m-auto pb-4 snap-x will-change-[opacity]">
							<div className="flex-shrink-0 text-lg md:text-lg md:leading-normal p-8 rounded-lg bg-primary200 mr-20 last:mr-0 snap-start min-w-[280px] max-w-[350px]">
								<CYtPlaya
									vid="q6pKAXEPORg"
									cinema
									start={0}
									className="rounded-lg"
								/>
								<p className="font-semibold my-2 mt-8 text-xl">
									Trader
								</p>
								<p className="font-light pb-8">
									Your prefer staying liquid and your primary
									goal is to multiply your funds through
									cryptocurrency trading.
								</p>
							</div>
							<div className="flex-shrink-0 text-lg tracking-wide p-8 rounded-lg bg-primary200 mr-20 last:mr-0 snap-start min-w-[280px] max-w-[350px]">
								<CYtPlaya
									vid="Qc4UtsJXbsM"
									cinema
									start={0}
									className="rounded-lg"
								/>
								<p className="font-semibold my-2 mt-8 text-xl">
									Investor
								</p>
								<p className="font-light pb-8">
									You believe HODLing is the key to building a
									financial fortress.
								</p>
							</div>
							<div className="flex-shrink-0 text-lg md:text-lg md:leading-normal p-8 rounded-lg bg-primary200 mr-20 last:mr-0 snap-start min-w-[280px] max-w-[350px]">
								<CYtPlaya
									vid="HxFw_9s1eks"
									cinema
									start={0}
									className="rounded-lg"
								/>
								<p className="font-semibold my-2 mt-8 text-xl">
									Just Starting Out
								</p>
								<p className="font-light pb-8">
									Your are here out of curiosity in
									cryptocurrencies and up for learning just
									about everything there is to it.
								</p>
							</div>
						</div>
					</div>
				</div>
				<div className="relative">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={pattern_4.src}
						alt="pattern"
						className="w-full"
					/>
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={box2_pic.src}
						alt="boxes"
						className="-translate-x-1/2 -translate-y-1/2 top-0 absolute right-0 transform z-20"
					/>
				</div>
			</div>
			<div className="bg-white text-primary py-20 -mt-1 relative z-10 text-center">
				<h3 className="text-center mb-16 text-3xl">
					Kickoff Your Journey in{' '}
					<span className="text-primary100">just 2 steps</span>
				</h3>
				<div className="flex justify-center items-end my-16">
					<div className="mx-10 text-center">
						<img src={fill_details_img.src} alt="fill details" />
						<p className="font-semibold">1. Fill up your details</p>
					</div>
					<div className="mx-10 text-center">
						<img src={start_trading_img.src} alt="start trading" />
						<p className="font-semibold">2. Start Trading</p>
					</div>
				</div>
				<p className="text-center sm:text-lg md:text-3xl font-semibold">
					It only takes 5 minutes..
				</p>
				<Button
					noTransform
					className="rounded-full normal-case mt-12"
					variant="primary"
					onClick={() => {
						openNewLink('/trade/#/signup');
					}}
				>
					Sign up with Bitbns Now
				</Button>
			</div>
			<div>
				<div className="relative text-center">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={pattern_5.src}
						alt="pattern"
						className="w-full"
					/>
				</div>
				<div className="container py-20 px-4 text-white">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={why_bitbns_pic.src}
						alt="why_bitbns_pic"
						className="m-auto my-10 mb-20"
					/>
					<h3 className="text-center mb-16 text-3xl">Why Bitbns?</h3>
					<div className="flex flex-wrap xs:w-11/12 lg:w-4/5 m-auto font-light leading-relaxed text-md">
						<div className="sm:w-1/2">
							<div className="flex py-8 pb-16 items-start">
								<img
									src={why_bitbns_1.src}
									alt="Safe and Secure"
									width="120"
									height="104.4"
									className="flex-shrink-0"
								/>
								<div className="px-5 md:px-8 lg:px-16 text-gray-400 md:text-lg">
									<h3 className="text-xl text-white font-semibold">
										Safe and Secure
									</h3>
									There&apos;s KYC, 2FA, Fingerprint/PIN
									access, and a lot more. Because lots of
									security is always a plus.
								</div>
							</div>
						</div>
						<div className="sm:w-1/2">
							<div className="flex py-8 pb-16 items-start">
								<img
									src={why_bitbns_2.src}
									alt="Automated Buy and Sell"
									width="120"
									height="122.4"
									className="flex-shrink-0"
								/>
								<div className="px-5 md:px-8 lg:px-16 text-gray-400 md:text-lg">
									<h3 className="text-xl text-white font-semibold">
										Automated Buy and Sell
									</h3>
									Bitbns lets you automate your orders with
									advanced tools & features.
								</div>
							</div>
						</div>
						<div className="sm:w-1/2">
							<div className="flex py-8 pb-16 items-start">
								<img
									src={why_bitbns_3.src}
									alt="Extra Downside Protection"
									width="120"
									height="93.60"
									className="flex-shrink-0"
								/>
								<div className="px-5 md:px-8 lg:px-16 text-gray-400 md:text-lg">
									<h3 className="text-xl text-white font-semibold">
										Extra Downside Protection
									</h3>
									Ensure least risk with Bracket Orders that
									come with Trailing Stop Limit.
								</div>
							</div>
						</div>
						<div className="sm:w-1/2">
							<div className="flex py-8 pb-16 items-start">
								<img
									src={why_bitbns_4.src}
									alt="Verified Network"
									width="120"
									height="104.4"
									className="flex-shrink-0"
								/>
								<div className="px-5 md:px-8 lg:px-16 text-gray-400 md:text-lg">
									<h3 className="text-xl text-white font-semibold">
										Verified Network
									</h3>
									Our formally verified network is well-vetted
									against security issues and operational
									inefficiencies.
								</div>
							</div>
						</div>
						<div className="sm:w-1/2">
							<div className="flex py-8 pb-16 items-start">
								<img
									src={why_bitbns_5.src}
									alt="24x7 Customer Support"
									width="120"
									height="123.91"
									className="flex-shrink-0"
								/>
								<div className="px-5 md:px-8 lg:px-16 text-gray-400 md:text-lg">
									<h3 className="text-xl text-white font-semibold">
										24x7 Customer Support
									</h3>
									We&apos;re all ears, always. Hit up our
									customer support team anytime and get a
									resolution in no time.
								</div>
							</div>
						</div>
					</div>

					<div className="flex justify-between items-center overflow-auto scrolling-touch text-md md:text-lg lg:text-xl font-light lg:w-3/4 m-auto snap-x will-change-[opacity]">
						<div className="flex items-start bg-primary500 p-6 px-6 rounded-lg snap-start min-w-[280px] max-w-[350px]">
							<img
								// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
								src={fact_2.src}
								alt="volume"
								className="mr-5"
							/>
							<div>
								<p className="font-semibold mb-4">
									Volume (24h)
								</p>
								<p>
									$
									{millify(tradeVolume24h, {
										units: [
											'',
											'Thousand',
											'Million',
											'Billion',
										],
										space: true,
									})}
								</p>
							</div>
						</div>

						<div className="flex items-start mx-12 bg-primary500 p-6 px-6 rounded-lg snap-start min-w-[280px] max-w-[350px]">
							<img
								// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
								src={fact_1.src}
								alt="volume"
								className="mr-5"
							/>
							<div>
								<p className="font-semibold mb-4">Coins</p>
								<p>{balanceCoins.length}+ Digital Assets</p>
							</div>
						</div>

						<div className="flex items-start bg-primary500 p-6 px-6 rounded-lg snap-start min-w-[280px] max-w-[350px]">
							<img
								// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
								src={fact_3.src}
								alt="volume"
								className="mr-5"
							/>
							<div>
								<p className="font-semibold mb-4">
									Total Users
								</p>
								<p>40 lakh+ Active Users</p>
							</div>
						</div>
					</div>
				</div>
				<img
					// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
					src={pattern_6.src}
					alt="pattern"
					className="w-full"
				/>
			</div>
			<div className="py-20 -mt-1 relative z-10 bg-miscyellow">
				<div className="w-11/12 md:w-2/3 lg:w-1/2 m-auto text-primary md:text-lg">
					<p className="text-center leading-relaxed">
						I entered the market with &quot;Crypto is a scam!&quot;
						phrase and mindset. My first exchange was Bitbns and i
						was pretty scared while investing but this exchange is
						very user friendly, Easy to understand. Year after year
						the trust developed and by now believe me I dug into the
						whole team and was mesmerized how Bitbns was created.
					</p>
					<div className="flex justify-center items-center my-8">
						<div className="mr-5">
							<img
								src={user_pic_2.src}
								alt="user-pic"
								width="55"
								height="55"
								className="rounded-full"
							/>
						</div>
						<div className="text-left">
							<p className="mb-2 font-semibold">
								Dr. Parth Kavathia
							</p>
							<p className="text-sm">Doctor</p>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div className="relative -mt-1">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={pattern_7.src}
						alt="pattern"
						className="w-full"
					/>
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={boxes_pic.src}
						alt="boxes"
						width="100"
						className="-translate-x-1/2 -translate-y-1/2 absolute right-0 transform z-20"
					/>
				</div>
				<div className="container flex flex-col md:flex-row items-start py-20 text-white">
					<div className="leading-relaxed text-lg font-light md:mx-10 lg:mx-20 lg:my-16 text-left sm:text-center">
						<p>
							Bitbns is a part of Buyhatke Internet Pvt. Ltd. -
							the parent organisation, which was incorporated in
							2015. With {balanceCoins.length}+ cryptocurrencies
							listed at present, Bitbns allows users to buy and
							sell cryptocurrencies at best available prices and
							offers ease of trading like no other cryptocurrency
							exchange. Some of the top cryptocurrencies one can
							trade on Bitbns are Bitcoin (BTC), Ethereum (ETH),
							Ripple (XRP), Litecoin (LTC), Binance Coin (BNB),
							Neo (NEO) and more.
						</p>
						<p className="my-16">
							Get the new & revamped Bitbns app today. Available
							on both Android and iOS.
						</p>
						{/* <div className="flex items-center justify-center md:justify-start"> */}
						<div className="flex items-center justify-center">
							<a
								href="https://play.google.com/store/apps/details?id=com.bitbns&referrer=utm_source%3DbitbnsTradeFtr%26utm_medium%3Dwebsite"
								target="_blank"
								rel="noreferrer noopener"
								className="mr-4"
							>
								<img
									src="https://bitbns.com/assets/img/google-play-badge.svg"
									alt="Google Play"
									height="40"
									width="128"
								/>
							</a>
							<a
								href="https://itunes.apple.com/in/app/bitbns-crypto-trading-exchange/id1346160076?mt=8"
								target="_blank"
								rel="noreferrer noopener"
							>
								<img
									src="https://bitbns.com/assets/img/app-store-badge.svg"
									alt="Apple App Store"
									height="40"
									width="128"
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div className="relative">
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={pattern_8.src}
						alt="pattern"
						className="w-full"
					/>
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={box_pic.src}
						alt="box"
						className="-mt-10 absolute mr-20 right-0 top-0 z-20 hidden md:inline-block"
					/>
				</div>
				<div className="bg-primary500 py-20 -mt-1 relative z-10">
					<div className="container flex flex-col md:flex-row items-center md:items-start justify-between m-auto text-center text-white w-11/12">
						<div className="md:w-1/2">
							<p className="leading-normal text-lg">
								Bitbns is the only exchange in India which is
								standing alone strongly with incredible
								services, growing rapidly. Apart from this they
								provide 24/7 live support service & for me good
								customer support is everything.
							</p>
							<div className="flex justify-center items-center my-12">
								<div className="mr-5">
									<img
										src={user_pic_3.src}
										alt="user-pic"
										width="55"
										height="55"
										className="rounded-full"
									/>
								</div>
								<div className="text-left">
									<p className="text-green-400 mb-2 text-lg">
										Sachin sangwan
									</p>
									<p className="text-sm">Student, B.Sc</p>
								</div>
							</div>
						</div>
						<div className="flex-shrink-0">
							<p className="text-2xl my-10">
								Create your FREE Account
							</p>
							<Button
								className="rounded-full leading-normal normal-case py-3 px-10 text-sm md:text-md lg:text-lg"
								variant="primary"
								onClick={() => {
									openNewLink('/trade/#/signup');
								}}
							>
								Sign Up with Bitbns
							</Button>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	);
};

export default connect('currentRate, isLoggedIn')(Home);
